import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import '../../styles/main.css';
import CxDialog from './CxDialog';
import CxTable from './CxTable';



const CxDlgTable = props => {
  let r_table = React.useRef(null);

  const { onSelect, onClose, open, group, refColors, refSuffixes, onButtonAddOTF, ...rest } = props;

  const [filter, setFilter] = React.useState(rest.filter);
  
  const doOperation = async (op, row) => {
    if (op === 'c') {
      if (onButtonAddOTF !== undefined) {
        onButtonAddOTF();
      }
    } else {
      onSelect(row);
    }
  }

  useImperativeHandle(props.xref, () => {
    return {
      getType, getTable, setFilter,
    };
  });
  const getType = () => { return 'CxDlgTable' };
  const getTable = () => { return r_table.current };

  return (
    <div>

      <CxDialog
        //xref={r_dlg}
        title={rest.title}
        open={open}
        onClose={() => onClose()}
        height={rest.height || '450px'}
        >

        <CxTable
          xref={r_table}
          origin='CxDlgTable'
          hasSearchBox={rest.hasSearchBox}
          hasButtonAdd={onButtonAddOTF}
          tooltip={rest.tooltip}
          forceOptions={rest.forceOptions}
          url={rest.url}
          filter={filter || ''}
          group={group || ''}
          columns={rest.columns}
          optionalColumns={rest.optionalColumns}
          onOptions={rest.onOptions}
          onOpenForm={doOperation}
          refColors={refColors}
          refSuffixes={refSuffixes}
        />
      </CxDialog>

    </div>
  );
};

export default CxDlgTable;
